import { Button, Center, Stack, Text } from "@mantine/core";

/**
 * Last-resort fallback rendered by the root error boundary in main.tsx.
 * Mounted above the router, AuthProvider and i18n Suspense — must not
 * depend on translations, auth state or anything else that may be the
 * thing that just crashed.
 */
function AppCrashScreen() {
  return (
    <Center mih="100vh" bg="bluegray.1" p="md">
      <Stack align="center" gap="xs">
        <Text fw="bold" fz="lg">
          Something went wrong
        </Text>
        <Text c="dimmed" ta="center">
          Reload the page to continue.
        </Text>
        <Button mt="sm" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </Stack>
    </Center>
  );
}

export default AppCrashScreen;
